import { AxiosError, AxiosResponse } from 'axios';
import * as Sentry from '@sentry/react';
import { SERVICE_DOWN } from 'api/errors';
import { Tokens } from 'types';
import { setCookie } from 'utils';
import { AxiosUtils } from '../AxiosClient/AxiosClient';

export const catchHandler = (r: any | undefined, endpoint: string): Promise<any> => {
  const response: AxiosResponse<any> = (r as AxiosError).response || (r as AxiosResponse);
  if (response && response.data.code) {
    const message = JSON.stringify(response.data.message);
    return Promise.reject({ ...response.data, message });
  }
  Sentry.captureException(r, {
    tags: {
      api: 'UM',
      endpoint,
      ...AxiosUtils.enrichTags(r),
    },
  });
  return Promise.reject(SERVICE_DOWN);
};

export const setTokens = (result: AxiosResponse<Tokens>): Tokens => {
  const data = result.data;
  setCookie('access-token', data.token);
  setCookie('refresh-token', data.refreshToken);
  return data;
};
